<template>
  <rombo :class="['comun', xsClass, persona.class]" color="#F18800" :border="true"
         v-on:click.native="$emit('click',persona)"
         v-on:mouseover.native="$emit('mouseover', persona)"
         v-on:mouseleave.native="$emit('mouseleave', persona)"
         v-b-tooltip.hover :title="persona.name === 'Persona5' ? '' : persona.name">
    <img
      v-for="fotoKey in Object.keys(persona.fotos)"
      :src="persona.fotos[fotoKey]"
      :alt="persona.name"
      :class="fotoToShow === fotoKey ? 'd-block' : 'd-none'"
    />
  </rombo>
</template>

<script>
  import Rombo from '../components/Rombo'

  export default {
    name: 'RomboPersona',
    components: {Rombo},
    data () {
      return {
        fotoToShow: this.foto
      }
    },
    props: {
      foto: {
        type: String,
        default: 'front'
      },
      persona: {
        type: Object,
        default () {
          return {
            id: '',
            name: '',
            fotos: {}
          }
        }
      }
    },
    computed: {
      xsClass () {
        return this.persona.id === 4 ? 'centro' : ''
      }
    },
    methods: {
      switchFoto (val) {
        this.fotoToShow = val
      }
    }
  }
</script>

<style scoped lang="scss">
  .comun {
    width: 120px;
    height: 120px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: relative;
    z-index: 99999;
    cursor: pointer;

    // Extra large devices
    @media (min-width: 1400px) {
      width: 170px;
      height: 170px;
    }

    img {
      position: absolute;
      top: 5px;
      left: 8px;
      width: 108px;
      @media (min-width: 1400px) {
        width: 162px;
        top: -2px;
        left: 7px;
      }
    }
  }

  .centro{
    z-index: 0;
    cursor: default;

    img {
      width: 154px;
      position: absolute;
      top: -17px;
      left: -17px;
      @media (min-width: 1400px) {
        width: 226px;
        top: -29px;
        left: -28px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RomboPersona.vue